const PHONEPE_RESPONSE_CACHE_KEY = 'phonepe_payment_response';
const PHONEPE_PENDING_ORDER_KEY = 'phonepe_pending_order';
const PHONEPE_MERCHANT_ORDER_ID_KEY = 'phonepe_merchant_order_id';

export interface PhonePePaymentResponse {
  code?: string;
  transactionId?: string;
  merchantId?: string;
  amount?: string;
  providerReferenceId?: string;
  [key: string]: string | undefined;
}

export const cachePhonePeResponse = (response: PhonePePaymentResponse) => {
  try {
    sessionStorage.setItem(PHONEPE_RESPONSE_CACHE_KEY, JSON.stringify({ ...response, cachedAt: Date.now() }));
  } catch (e) {
    console.warn('Failed to cache payment response:', e);
  }
};

export const getCachedPhonePeResponse = (): (PhonePePaymentResponse & { cachedAt?: number }) | null => {
  try {
    const raw = sessionStorage.getItem(PHONEPE_RESPONSE_CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearCachedPhonePeResponse = () => {
  try {
    sessionStorage.removeItem(PHONEPE_RESPONSE_CACHE_KEY);
  } catch {}
};

export const setPendingOrderPayload = (order: object) => {
  try {
    sessionStorage.setItem(PHONEPE_PENDING_ORDER_KEY, JSON.stringify(order));
  } catch (e) {
    console.warn('Failed to store pending order:', e);
  }
};

export const getPendingOrderPayload = (): object | null => {
  try {
    const raw = sessionStorage.getItem(PHONEPE_PENDING_ORDER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearPendingOrderPayload = () => {
  try {
    sessionStorage.removeItem(PHONEPE_PENDING_ORDER_KEY);
  } catch {}
};

export const setMerchantOrderId = (orderId: string) => {
  try {
    sessionStorage.setItem(PHONEPE_MERCHANT_ORDER_ID_KEY, orderId);
  } catch (e) {
    console.warn('Failed to store merchant order id:', e);
  }
};

export const getMerchantOrderId = (): string | null => {
  try {
    return sessionStorage.getItem(PHONEPE_MERCHANT_ORDER_ID_KEY);
  } catch {
    return null;
  }
};

export const clearMerchantOrderId = () => {
  try {
    sessionStorage.removeItem(PHONEPE_MERCHANT_ORDER_ID_KEY);
  } catch {}
};
